import {
  categories,
  getClientFormats,
  getDashboardInfo,
  getSelectedClient,
  getUserStoresAllList,
  isLoadingCategories,
  isLoadingClientFormats,
  isLoadingDashboard,
  isLoadingExcelDownload,
  isLoadingLastProductSources,
  isLoadingStockCategories,
  isLoadingUserStores,
  isLoadingUserSuppliers,
  lastProductSources,
  stockCategories,
  userChains,
  userSuppliers,
} from 'core/selectors';
import { getDashboard } from 'core/slices/dashboards';
import { downloadExcel } from 'core/slices/general';
import { getLastProductSources, getStockCategories } from 'core/slices/productsStates';
import { getStoreCategories } from 'core/slices/store';
import { getUserStores, getUserSuppliers } from 'core/slices/users';
import { connect } from 'react-redux';

import Dashboards from '../../../../components/features/dashboards/Dashboards';

export default connect(state => ({
  isLoadingDashboard: isLoadingDashboard(state),
  isLoadingUserStores: isLoadingUserStores(state),
  selectedClient: getSelectedClient(state),
  userChains: userChains(state),
  userStores: getUserStoresAllList(state),
  dashboardInfo: getDashboardInfo(state),
  isLoadingExcelDownload: isLoadingExcelDownload(state),
  categories: categories(state),
  isLoadingCategories: isLoadingCategories(state),
  suppliers: userSuppliers(state),
  isLoadingSuppliers: isLoadingUserSuppliers(state),
  clientFormats: getClientFormats(state),
  isLoadingClientFormats: isLoadingClientFormats(state),
  stockCategories: stockCategories(state),
  isLoadingStockCategories: isLoadingStockCategories(state),
  lastProductSources: lastProductSources(state),
  isLoadingLastProductSources: isLoadingLastProductSources(state),
}), {
  downloadExcel,
  getDashboard,
  getUserStores,
  getStoreCategories,
  getUserSuppliers,
  getStockCategories,
  getLastProductSources
})(Dashboards);
